module.exports = __webpack_public_path__ + "fonts/error.9552433fc5c3829872d2.svg";